const DAYS = new Set([
	'Monday',
	'Tuesday',
	'Wednesday',
	'Thursday',
	'Friday',
	'Saturday',
	'Sunday',
]);

/**
 * Normalize an API time to the form's HH:mm value.
 * @param {*} value canonical time value
 * @return {string|undefined} normalized time
 */
function mapTime(value) {
	if (typeof value !== 'string') return undefined;
	const match = value.trim().match(/^([01]\d|2[0-3]):([0-5]\d)(?::[0-5]\d)?$/);
	return match ? `${match[1]}:${match[2]}` : undefined;
}

/**
 * Convert canonical schedule values to Canvas form fields.
 * @param {object} values canonical schedule values
 * @return {object} Canvas schedule field patch
 */
export function mapSsidSchedulePrefill(values = {}) {
	const patch = {};
	if (typeof values.profile_name === 'string') {
		patch.profileName = values.profile_name;
	}
	if (Array.isArray(values.selected_days)) {
		patch.scheduleDays = values.selected_days.filter((day) => DAYS.has(day));
	}
	const startTime = mapTime(values.start_time);
	if (startTime) patch.startTime = startTime;
	const endTime = mapTime(values.end_time);
	if (endTime) patch.endTime = endTime;
	return patch;
}
